var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"party-richtext-panel"},[(_vm.entry && _vm.entry.bodyContent)?_c('div',{staticClass:"rich-body",domProps:{"innerHTML":_vm._s(_vm.entry.bodyContent)}}):_c('p',{staticClass:"muted-copy"},[_vm._v("暂无已发布内容，请在管理后台维护")])])
}
var staticRenderFns = []

export { render, staticRenderFns }